import React from 'react';
import { Link } from 'react-router-dom';
import s from './index.module.css';

export function NotFound() {
  return (
    <div className={s.notFound}>
      <div className={s.container}>
        <h1 className={s.errorCode}>404</h1>
        {/* <div className={s.imageContainer}>
          <img src="" alt="Page not found" className={s.errorImage} />
        </div> */}
        <h2 className={s.title}>Page Not Found</h2>
        <p className={s.message}>
          The page you are looking for does not exist or has been moved.
        </p>
        <Link to="/" className={s.homeLink}>
          Back to Home
        </Link>
      </div>
    </div>
  );
}